module.exports = __webpack_public_path__ + "img/info.c549166.svg";